<template>
    <CostableTableRow
        class="position-relative hover:bg-initial larger-font bolder-font"
        :is-heading-row="true"
    >
        <template v-slot:drag>
            <span
                v-if="!isOtherCosts && $store.getters['costable/isEditable']"
                v-b-tooltip.hover.right.d50
                class="CostableTableGroupHeadingHandle"
                title="Drag to Reorder"
            >
                <i class="fa fa-bars" />
            </span>
        </template>
        <template v-slot:select>
            <CostableTableSelectCheckbox
                v-if="$store.getters['costable/isEditable']"
                :value="allSelected"
                :indeterminate="indeterminate"
                :disabled="!hasCosts"
                @input="selectGroup"
            />
        </template>
        <template v-slot:heading>
            <div
                v-b-tooltip.hover.top.d50
                class="cursor-pointer d-flex justify-content-between"
                title="Toggle costs"
                @click="toggleExpanded"
            >
                <div class="flex-grow-1">
                    <span
                        class="bolder-font larger-font"
                    >
                        {{ group.name }}
                    </span>
                    <div
                        v-if="group.description_html"
                        class="last:mb-0 initial-font"
                        v-html="group.description_html"
                    />
                </div>

                <button class="text-muted small btn btn-xs btn-default">
                    <i
                        class="fa fa-fw"
                        :class="`fa-${expanded ? 'eye-slash' : 'eye'}`"
                    />
                    {{ expanded ? 'Hide' : 'Show' }} costs
                </button>
            </div>

        </template>

        <template
            v-if="!expanded"
            v-slot:totalCost
        >
            <span
                v-b-tooltip.hover.top.d50
                title="Cost"
            >
                {{ formatCurrency(group.totals.cost) }}
            </span>
        </template>

        <template
            v-if="!expanded"
            v-slot:totalPrice
        >
            <span
                v-b-tooltip.hover.top.d50
                title="Price"
            >
                {{ formatCurrency(group.totals.price) }}
            </span>
        </template>

        <template
            v-if="!expanded"
            v-slot:markup
        >
            <span
                v-b-tooltip.hover.top.d50
                title="Markup"
            >
                {{ formatCurrency(group.totals.markup) }}
            </span>
        </template>

        <template
            v-if="!expanded"
            v-slot:margin
        >
            <span
                v-b-tooltip.hover.top.d50
                title="Margin"
            >
                {{ formatPercentage(group.totals.margin) }}
            </span>
        </template>

        <template
            v-if="!expanded"
            v-slot:commissionDue
        >
            <span
                v-b-tooltip.hover.top.d50
                title="Commission Due"
            >
                {{ formatCurrency(group.totals.commission_due) }}
            </span>
        </template>

        <template
            v-if="!expanded"
            v-slot:totalProfit
        >
            <span
                v-b-tooltip.hover.top.d50
                title="Total Profit"
            >
                {{ formatCurrency(group.totals.profit) }}
            </span>
        </template>

        <template v-slot:actions>
            <CostableTableGroupActionsDropdown
                v-if="!!group.id"
                :group="group"
            />
        </template>
    </CostableTableRow>
</template>

<script>
import {formatCurrency, formatPercentage} from '@/utils/helpers';
import CostableTableSelectCheckbox from './CostableTableSelectCheckbox';
import CostableTableGroupActionsDropdown from './CostableTableGroupActionsDropdown';
import CostableTableRow from './CostableTableRow';

export default {

    components: {
        CostableTableSelectCheckbox,
        CostableTableGroupActionsDropdown,
        CostableTableRow,
    },

    props: {
        group: {
            type: Object,
            required: true,
        },
        expanded: {
            type: Boolean,
            default: false,
        },
    },

    computed: {
        hasCosts() {
            return this.group.costs.length > 0;
        },
        selectedCount() {
            return this.group.costs.filter(cost => cost.selected).length;
        },
        allSelected() {
            return this.selectedCount === this.group.costs.length
                && this.hasCosts;
        },
        indeterminate() {
            return this.selectedCount > 0
                && this.selectedCount < this.group.costs.length;
        },
        isOtherCosts() {
            return !this.group.id;
        },
    },

    methods: {
        selectGroup(value) {
            this.$store.dispatch('costable/selectGroup', {
                groupId: this.group.id,
                value,
            });
        },
        toggleExpanded() {
            this.$emit('toggleExpanded');
        },
        formatCurrency,
        formatPercentage,
    },

};
</script>

<style lang="scss" scoped>
.CostableTableGroupHeadingHandle {
    cursor: ns-resize;
}
.right-0 {
    right: 0;
}
.larger-font {
    font-size: 14px;
}
.bolder-font {
    font-weight: 600;
}

.initial-font {
    font-weight: initial;
}

@media (max-width: 768px) {
    .right-on-mobile {
        position: absolute;
        right: 0;
    }
}
</style>
